import React, { lazy } from 'react';
import { Route } from 'react-router-dom';

const AuthPage = lazy(() => import(/* webpackChunkName: "auth-page" */ 'pages/auth-page'));
const Logout =   lazy(() => import(/* webpackChunkName: "logout" */ 'pages/logout'));

const renderAuthRoutes = () => [
  <Route
    key="login"
    name="login"
    path="/login"
    element={<AuthPage stage="LOGIN"/>}
  />,
  <Route
    key="register"
    name="register"
    path="/register"
    element={<AuthPage stage="REGISTER"/>}
  />,
  <Route
    key="forgot"
    name="forgot"
    path="/forgot"
    element={<AuthPage stage="FORGOT"/>}
  />,
  <Route
    key="logout"
    name="logout"
    path="/logout"
    element={<Logout/>}
  />
];

export default renderAuthRoutes;
